const AUTOMATIC_LEGACY_THEMES = new Set(['system', 'v2system', 'highcontrast']);
const LIGHT_LEGACY_THEMES = new Set([
  'white',
  'sepia',
  'yellow',
  'green',
  'highcontrast-light',
  'lightv2',
]);
const DARK_LEGACY_THEMES = new Set([
  'black',
  'highcontrast-dark',
  'darkv2',
]);

export const resolveColorTheme = (
  theme,
  { prefersDark = false } = {},
) => {
  if (!theme || theme === 'light' || LIGHT_LEGACY_THEMES.has(theme)) {
    return 'light';
  }

  if (theme === 'dark' || DARK_LEGACY_THEMES.has(theme)) {
    return 'dark';
  }

  if (AUTOMATIC_LEGACY_THEMES.has(theme)) {
    return prefersDark ? 'dark' : 'light';
  }

  throw new Error(`Unsupported color theme: ${theme}`);
};

const readSystemPreferences = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    throw new Error('Theme resolution requires window.matchMedia');
  }

  return {
    prefersDark: window.matchMedia('(prefers-color-scheme: dark)').matches,
  };
};

const updateBrowserThemeColor = () => {
  const themeColor = getComputedStyle(document.documentElement)
    .getPropertyValue('--bg-primary')
    .trim();

  if (!themeColor) {
    throw new Error('Cannot update browser theme color: --bg-primary is unresolved');
  }

  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', themeColor);
};

export const applyColorTheme = (theme, preferences) => {
  if (typeof document === 'undefined') {
    throw new Error('Theme application requires a document');
  }

  const resolvedTheme = resolveColorTheme(
    theme,
    preferences ?? (AUTOMATIC_LEGACY_THEMES.has(theme) ? readSystemPreferences() : undefined),
  );

  if (resolvedTheme === 'light') {
    document.documentElement.removeAttribute('data-theme');
  } else {
    document.documentElement.setAttribute('data-theme', resolvedTheme);
  }

  updateBrowserThemeColor();
  return resolvedTheme;
};
